import { render, staticRenderFns } from "./BrainViz.vue?vue&type=template&id=7a14ead0&scoped=true"
import script from "./BrainViz.vue?vue&type=script&lang=js"
export * from "./BrainViz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a14ead0",
  null
  
)

export default component.exports